"use strict";
export const BINANCE_API_BASE = process.env.REACT_APP_BINANCE_PROXY || "/api/binance";
export const BINANCE_NATIVE_TOKEN = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
export const BINANCE_CHAIN_ID = {
  56: "56"
};
export const BINANCE_MIN_SLIPPAGE_PERCENT = 0.05;
export const BINANCE_MAX_SLIPPAGE_PERCENT = 50;
export const BINANCE_DEFAULT_GAS_PRICE_WEI = "1000000000";
export const BINANCE_DEFAULT_GAS_LIMIT = 2e5;
export function getBinanceChainId(chainId) {
  return chainId === void 0 ? void 0 : BINANCE_CHAIN_ID[chainId];
}
export function clampBinanceSlippage(slippagePercent) {
  return Math.min(
    BINANCE_MAX_SLIPPAGE_PERCENT,
    Math.max(BINANCE_MIN_SLIPPAGE_PERCENT, slippagePercent)
  );
}
